<template>
<div class="upload">
	<img :src="ossImg(url,'s')" alt="">
	<a :href="ossImg(url)" target="_blank">查看大图</a>
	<a @click="$emit('del-img')" v-if="$route.query.orderType==1&&del" style="color:red">删除</a>
</div>
</template>
<script>
export default {
	props:{
		url:String,
		del:{
			type: Boolean,
			default:false
		}
	}
}
</script>
<style scoped lang="less">
.upload{
	margin-right: 10px;
	// margin-top: 20px;
	width:90px;
	height:160px;
	text-align:center;
	position:relative;
	img{
		width:100%;
		height:140px;
	}
	a{
		// position:absolute;
		// left:0;
		// right:0;
		// bottom:0;
		// font-size: 12px;
		// line-height:1.3;
		position: relative;
    	top: -15px;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/Image.vue